import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";

import "./sentry/config";

// biome-ignore lint/style/noNonNullAssertion: according to docs
ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
